import { useAuth } from '../AuthContext';
import { FolderIcon, PersonIcon, TemplateIcon, NewIcon } from './Icons';

const MenuItem = ({ icon, label, onClick, disabled = false }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="flex flex-col items-center justify-center gap-0.5 px-3 py-1.5 text-gray-400 hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <div className="w-7 h-6 flex items-center justify-center">
      {icon}
    </div>
    <span className="text-[10px] font-medium">{label}</span>
  </button>
);

export const BottomMenu = ({
  onOpenClick,
  onLoginClick,
  onTemplateClick,
  onNewClick
}) => {
  const { user } = useAuth();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40">
      <div className="bg-[#4A4A4A]/10 backdrop-blur-sm border border-white/20 max-w-[500px] mx-5 sm:mx-auto rounded-full mb-3 sm:mb-6">
        <div className="flex justify-around sm:justify-center items-center gap-0 sm:gap-5 py-1 px-4">
          {!user && (
            <MenuItem
              icon={<PersonIcon className="w-6 h-6" />}
              label="Login"
              onClick={onLoginClick}
            />
          )}
          <MenuItem
            icon={<FolderIcon className="w-6 h-6" />}
            label="My Lists"
            onClick={onOpenClick}
            disabled={!user}
          />
          <MenuItem
            icon={<TemplateIcon className="w-6 h-5" />}
            label="Template"
            onClick={onTemplateClick}
          />
          <MenuItem
            icon={<NewIcon className="w-6 h-4 -mb-1.5" />}
            label="New"
            onClick={onNewClick}
          />
        </div>
      </div>
    </div>
  );
};
